import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.state;

const getState = createSelector(getData, state => values(state));

export default getState;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getState.js